// in src/Dashboard.js
import * as React from "react";
import { Card, CardContent, CardHeader, Grid } from '@mui/material';
import { getAuthData, httpClient, url_api } from "../constant/constant";
import { useAuthProvider, useNotify } from "react-admin";
import { getStringFromDate } from "../constant/DateInput";
import QRCode from "react-qr-code";

const BestEmployee = () => {
    const notify = useNotify();
    const [jumlahMitra, setJumlahMitra] = React.useState(0);
    const [jumlahAlokasi, setJumlahAlokasi] = React.useState(0);
    const [sbml1, setSbml1] = React.useState(0);
    const [sbml2, setSbml2] = React.useState(0);
    let date = new Date();
    const month = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];


    return <div>
        <Card id="dash" key="dash" style={{marginTop: "20px"}}>
             <CardHeader title={`Petugas Layanan Terbaik Juli 2024`} />
             <CardContent>
                <img src="https://sultradata.com/project/antrian-api/best_employee.png" style={{maxWidth: "100%"}}></img>

             </CardContent>
        </Card>
    </div>
};

export default BestEmployee;